export interface Bonus {
  badge: string
  title: string
  value: string
  description: string
  items?: string[]
  image: string
}

export const bonuses: Bonus[] = [
  {
    badge: 'Bonus #1',
    title: 'The 30 Occlusal Analysis Mistakes Atlas',
    value: '$37',
    description:
      'A visual collection of common reasoning, interpretation, and sequencing mistakes. Learn to recognize where confusion can occur before turning an observation into an intervention.',
    image:
      'https://cdn.magicpatterns.com/uploads/qywHfqem2PdC953P4Rky6i/BONUS_1_OCLUSION360-EN.png',
  },
  {
    badge: 'Bonus #2',
    title: 'The “Before the Paper” Checklist™',
    value: '$27',
    description:
      'A quick-reference tool designed to remind you what to evaluate before reaching for the articulating paper.',
    items: ['One page', 'One sequence', 'One reference you can keep close at hand'],
    image:
      'https://cdn.magicpatterns.com/uploads/434kunZSNyEZu3478KUEpy/BONUS_2_OCLUSION360-EN.png',
  },
  {
    badge: 'Bonus #3',
    title: '20 Occlusion 360™ Case Studies',
    value: '$39',
    description:
      '20 educational scenarios designed to help you practice structured occlusal analysis. Each case includes:',
    items: [
      'Case context',
      'Relevant information',
      'Key questions',
      'Possible hypotheses',
      'Analysis framework',
      'Case discussion',
      'Key takeaway',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/oxmNzsRucUEjyPkkC42WLF/BONUS_3_OCLUSION360-EN.png',
  },
  {
    badge: 'Bonus #4',
    title: 'Clinical Documentation Kit',
    value: '$19',
    description: 'Educational templates to organize:',
    items: [
      'Observations',
      'Clinical decisions',
      'Before-and-after information',
      'Follow-up',
      'Case notes',
      'Final review',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/wRbWVJkqDMJZ73LsNQP9bm/BONUS_4_OCLUSION360-EN.png',
  },
  {
    badge: 'Bonus #5',
    title: 'Occlusion 360™ Quick Reference Cards',
    value: '$25',
    description: 'Visual quick-reference cards covering:',
    items: [
      'The Occlusion 360™ sequence',
      'Key questions',
      'Common errors',
      'Refinement checklist',
      'Validation checklist',
      'System reminders',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/qQeTRyeHUM87zRujF2Ff4P/BONUS_5_OCLUSION360-EN.png',
  },
]
